import { Crop } from 'lucide-react'
import {
  NodeKind,
  TransformKind,
  createDefaultCropParams,
  summarizeOrientation,
} from '@/core/document'
import { IDENTITY_ORIENTATION } from '@/core/geometry'
import { CropPanel } from '@/tools/crop/CropPanel'
import { ToolKind, ToolTab, type TransformTool } from '@/tools/types'

export const CROP_TOOL: TransformTool = {
  kind: ToolKind.Transform,
  tab: ToolTab.Crop,
  transforms: [TransformKind.Orientation, TransformKind.Crop],
  definitions: {
    [TransformKind.Orientation]: {
      createDefault: () => ({ ...IDENTITY_ORIENTATION }),
      summarize: summarizeOrientation,
    },
    [TransformKind.Crop]: {
      createDefault: createDefaultCropParams,
      summarize: (params) => `${params.rect.width}×${params.rect.height}`,
    },
  },
  label: 'Crop',
  icon: Crop,
  appliesTo: (node) => node?.kind === NodeKind.Image,
  Panel: CropPanel,
}
